import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
/**
 * Validates the `inventoryTags` filter's id-shaped fields.
 *
 * These three are `String @db.Uuid` columns, so an unvalidated value reaches PostgreSQL as a uuid
 * predicate: `locationId: 'abc'` fails the whole query with `invalid input syntax for type uuid`
 * rather than a `BAD_INPUT` the caller can act on. `optionalUuidString` treats `''` as "not
 * filtering" (a cleared `<select>` posts exactly that) and rejects any other malformed value.
 *
 * The free-text filters (`partNumContains`, `lotNumberContains`) are deliberately absent: they are
 * substring searches with no format to validate, only a length bound, which `inventoryTagWhere`
 * enforces directly.
 */
export const inventoryTagFilterSchema = z.object({
    locationId: optionalUuidString('Invalid location selection.').nullish(),
    locationGroupId: optionalUuidString('Invalid warehouse selection.').nullish(),
    partId: optionalUuidString('Invalid part selection.').nullish(),
});
//# sourceMappingURL=tag-filter.js.map